function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#afc3d2;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -27.089)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M5.879,35.784H4.706v-.009a5.919,5.919,0,0,1,10.1-4.268l1.936-1.867a8.572,8.572,0,0,0-6.107-2.55A8.671,8.671,0,0,0,2,35.783H.816c-.727,0-1.024.486-.661,1.081l2.532,2.509c.5.5.8.518,1.322,0L6.54,36.864C6.9,36.27,6.605,35.784,5.879,35.784ZM21.27,34.74l-2.532-2.5c-.516-.516-.836-.485-1.321,0l-2.532,2.5c-.364.594-.067,1.08.66,1.08h1.171a5.92,5.92,0,0,1-10.1,4.226L4.679,41.91a8.623,8.623,0,0,0,14.741-6.09h1.188C21.337,35.82,21.633,35.333,21.27,34.74Z",
  transform: "translate(0)"
}));

var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.425,
    height: 17.367,
    viewBox: "0 0 21.425 17.367",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.dbee76e5.svg";
export { ForwardRef as ReactComponent };